<template >
    <v-card max-width="4520" raised="raised">

        <v-card-title>
            <v-icon class="mr-3">{{$props.type == 'site' ? 'mdi-radio-tower' : 'mdi-account-box'}}</v-icon><span v-text="$props.title ? $props.title : 'Image'"></span>
        </v-card-title>

        <v-divider />

        <v-card-text>
            <v-file-input color="#C42111" class="my-4" v-model="selectedFile" accept="image/png, image/jpeg" label="Image File" placeholder="Select a file" show-size @change="setupCropper" :rules="[$store.state.validationFuncs.maxFileSize(selectedFile, maxFileSize, maxFileSizeStr)]" />
            <v-row v-if="objectUrl">
                <v-col class="text-center" cols="12" sm="6">
                    <div class="overline">Original</div>
                    <div class="image-container elevation-4"><img class="image-preview" ref="source" :src="objectUrl" /></div>
                    <div class="d-flex justify-center">
                        <v-btn icon="icon" small="small" @click="resetCropper">
                            <v-icon small="small">mdi-aspect-ratio</v-icon>
                        </v-btn>
                        <div class="mx-2"></div>
                        <v-btn icon="icon" small="small" @click="rotateLeft">
                            <v-icon small="small">mdi-rotate-left</v-icon>
                        </v-btn>
                        <v-btn icon="icon" small="small" @click="rotateRight">
                            <v-icon small="small">mdi-rotate-right</v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col class="text-center" cols="12" sm="6">
                    <div class="overline">Preview</div>
                    <div class="image-container elevation-4"><img class="image-preview" :src="previewCropped" /></div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" color="#c42111" @click="$emit('cancel')">Cancel</v-btn>
            <v-btn color="#c42111" :disabled="!objectUrl" @click="processImage">Save</v-btn>
        </v-card-actions>

    </v-card>
</template>


<script>
import Cropper from 'cropperjs'
import debounce from 'lodash/debounce'
export default {
    name: 'ImageCropper',
    props: ['title', 'type', 'maxSize'],
    data () {
        return {
            cropper: null,
            objectUrl: null,
            previewCropped: null,
            selectedFile: null,
            debouncedUpdatePreview: debounce(this.updatePreview, 250),
            maxFileSize: 50000000
        }
    },

    computed: {
        maxFileSizeStr() {
            return TELSA.readableFileSize(this.maxFileSize);
        }
    },

    methods: {
        resetCropper () {
            this.cropper.reset();
        },

        rotateLeft () {
            this.cropper.rotate(-90);
        },

        rotateRight () {
            this.cropper.rotate(90);
        },

        setupCropper (selectedFile) {
            if (this.cropper) {
                this.cropper.destroy();
            }

            if (this.objectUrl) {
                window.URL.revokeObjectURL(this.objectUrl);
            }

            if (!selectedFile) {
                this.cropper = null;
                this.objectUrl = null;
                this.previewCropped = null;
                return;
            }

            if(selectedFile.size > this.maxFileSize) {
                return;
            }

            this.objectUrl = window.URL.createObjectURL(selectedFile);
            this.$nextTick(this.setupCropperInstance);
        },

        setupCropperInstance () {
            this.cropper = new Cropper(this.$refs.source, {
                aspectRatio: 1,
                crop: this.debouncedUpdatePreview
            });
        },

        updatePreview (event) {
            const canvas = this.cropper.getCroppedCanvas();
            this.previewCropped = canvas.toDataURL('image/png');
        },

        processImage() {
            const canvas = this.cropper.getCroppedCanvas();
            canvas.toBlob((blob) => {
                let base64data = '';
                let reader = new FileReader();
                reader.readAsDataURL(blob);
                let self = this;
                reader.onloadend = function() {
                    base64data = reader.result;
                    self.$emit('data', base64data);
                }            
            });
        }
    },

    created() {
        this.maxFileSize = this.$props.maxSize || this.maxFileSize;
    }
}
</script>


<style scoped>
    .image-container {
        display: inline-block;

        /* max-height: 100%;
        max-width: 100%; */

        max-height: 260px;
        max-width: 260px;
    }

    .image-preview {
        display: block;
        /* max-height: 229px; */

        max-height: 260px;
        max-width: 260px;

        /* max-height: 100%;
        max-width: 100%; */
    }
</style>


<style>

    .cropper-container {
        direction: ltr;
        font-size: 0;
        line-height: 0;
        position: relative;
        -ms-touch-action: none;
        touch-action: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .cropper-container img {
        display: block;
        height: 100%;
        image-orientation: 0deg;
        max-height: none !important;
        max-width: none !important;
        min-height: 0 !important;
        min-width: 0 !important;
        width: 100%;
    }

    .cropper-wrap-box,
    .cropper-canvas,
    .cropper-drag-box,
    .cropper-crop-box,
    .cropper-modal {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    .cropper-wrap-box,
    .cropper-canvas {
        overflow: hidden;
    }

    .cropper-drag-box {
        background-color: #fff;
        opacity: 0;
    }

    .cropper-modal {
        background-color: #000;
        opacity: 0.5;
    }

    .cropper-view-box {
        display: block;
        height: 100%;
        outline: 1px solid #39f;
        outline-color: rgba(51, 153, 255, 0.75);
        overflow: hidden;
        width: 100%;
    }

    .cropper-dashed {
        border: 0 dashed #eee;
        display: block;
        opacity: 0.5;
        position: absolute;
    }

    .cropper-dashed.dashed-h {
        border-bottom-width: 1px;
        border-top-width: 1px;
        height: calc(100% / 3);
        left: 0;
        top: calc(100% / 3);
        width: 100%;
    }

    .cropper-dashed.dashed-v {
        border-left-width: 1px;
        border-right-width: 1px;
        height: 100%;
        left: calc(100% / 3);
        top: 0;
        width: calc(100% / 3);
    }

    .cropper-center {
        display: block;
        height: 0;
        left: 50%;
        opacity: 0.75;
        position: absolute;
        top: 50%;
        width: 0;
    }

    .cropper-center::before,
    .cropper-center::after {
        background-color: #eee;
        content: ' ';
        display: block;
        position: absolute;
    }

    .cropper-center::before {
        height: 1px;
        left: -3px;
        top: 0;
        width: 7px;
    }

    .cropper-center::after {
        height: 7px;
        left: 0;
        top: -3px;
        width: 1px;
    }

    .cropper-face,
    .cropper-line,
    .cropper-point {
        display: block;
        height: 100%;
        opacity: 0.1;
        position: absolute;
        width: 100%;
    }

    .cropper-face {
        background-color: #fff;
        left: 0;
        top: 0;
    }

    .cropper-line {
        background-color: #39f;
    }

    .cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
    }

    .cropper-line.line-n {
        cursor: ns-resize;
        height: 5px;
        left: 0;
        top: -3px;
    }

    .cropper-line.line-w {
        cursor: ew-resize;
        left: -3px;
        top: 0;
        width: 5px;
    }

    .cropper-line.line-s {
        bottom: -3px;
        cursor: ns-resize;
        height: 5px;
        left: 0;
    }

    .cropper-point {
        background-color: #39f;
        height: 5px;
        opacity: 0.75;
        width: 5px;
    }

    .cropper-point.point-e {
        cursor: ew-resize;
        margin-top: -3px;
        right: -3px;
        top: 50%;
    }

    .cropper-point.point-n {
        cursor: ns-resize;
        left: 50%;
        margin-left: -3px;
        top: -3px;
    }

    .cropper-point.point-w {
        cursor: ew-resize;
        left: -3px;
        margin-top: -3px;
        top: 50%;
    }

    .cropper-point.point-s {
        bottom: -3px;
        cursor: s-resize;
        left: 50%;
        margin-left: -3px;
    }

    .cropper-point.point-ne {
        cursor: nesw-resize;
        right: -3px;
        top: -3px;
    }

    .cropper-point.point-nw {
        cursor: nwse-resize;
        left: -3px;
        top: -3px;
    }

    .cropper-point.point-sw {
        bottom: -3px;
        cursor: nesw-resize;
        left: -3px;
    }

    .cropper-point.point-se {
        bottom: -3px;
        cursor: nwse-resize;
        height: 20px;
        opacity: 1;
        right: -3px;
        width: 20px;
    }

    @media (min-width: 768px) {
        .cropper-point.point-se {
            height: 15px;
            width: 15px;
        }
    }

    @media (min-width: 992px) {
        .cropper-point.point-se {
            height: 10px;
            width: 10px;
        }
    }

    @media (min-width: 1200px) {
        .cropper-point.point-se {
            height: 5px;
            opacity: 0.75;
            width: 5px;
        }
    }

    .cropper-point.point-se::before {
        background-color: #39f;
        bottom: -50%;
        content: ' ';
        display: block;
        height: 200%;
        opacity: 0;
        position: absolute;
        right: -50%;
        width: 200%;
    }

    .cropper-invisible {
        opacity: 0;
    }

    .cropper-bg {
        /* background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC'); */
    }

    .cropper-hide {
        display: block;
        height: 0;
        position: absolute;
        width: 0;
    }

    .cropper-hidden {
        display: none !important;
    }

    .cropper-move {
        cursor: move;
    }

    .cropper-crop {
        cursor: crosshair;
    }

    .cropper-disabled .cropper-drag-box,
    .cropper-disabled .cropper-face,
    .cropper-disabled .cropper-line,
    .cropper-disabled .cropper-point {
        cursor: not-allowed;
    }


</style>


